module.exports = __webpack_public_path__ + "img/5-sapphire.47f58149.png";